import React, { useEffect, useState } from 'react';
import { EmpleadosAdapter } from '../../../../../infraestructure/persistence/rest/EmpleadosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboEmpleados from './combo';
//import { URLEMPLEADOS } from './constants';

export const ComboEmpleadosContainer = (props: any) => {
  
  const api = new EmpleadosAdapter();
  const { exceptionError, resultError } = useNotifications();
  let [data, setData] = useState<any>(undefined)
  let result: any;
  let [selectedOptions, setSelectedOptions] = useState<any>(props.selectedOptions);
  

  useEffect(()=>{
    getEmpleados();
	},[])
	
	useEffect(()=>{setSelectedOptions(props.selectedOptions)},[props.selectedOptions])

  const getEmpleados = async() =>{
    try {
      // result = props.expatriados === true ? await api.ListarUsuariosElecnorExpatriados() : await api.ListarUsuariosElecnor();
      result =  await api.ListarUsuariosElecnor();
      if(result && result!=="")
			{
        const filterUsersOmit = result.data.filter((f:any)=> f.fechaBaja===null || f.bajaDefinitiva===null)
        //el split con valores null fallan
        const filterUsers = props.dnFilters ? filterUsersOmit.filter((f:any)=> props.dnFilters.includes(f.direccion!==null && f.direccion.split('-')[0].trim())) : filterUsersOmit;
        setData([...filterUsers] || []);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }


  return <ComboEmpleados {...{...props,...{selectedOptions:selectedOptions}}} options={data}/>
};

export default ComboEmpleadosContainer;